import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { normalizeCurrencyFormat } from 'src/utils/form/normalization';
import './IRARecurringContributionLimit.scss';

import { IRA_RECURRING_CONTRIBUTION_LIMIT_MODAL } from '../../redux/modules/modals/modals.module';
import Button from '../Shared/Button/Button';
import Checkbox from '../Shared/Checkbox/Checkbox';
import If from '../Shared/If/If';
import { moduleActions } from '../../redux/modules';
import { getExecuteRecurringPurchase } from '../../redux/modules/executeRecurringPurchase/executeRecurringPurchase.selectors';
import TRP from '../Shared/TRP/TRP';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../redux/modules/authentication/authentication.module.selectors';

class IRARecurringContributionLimit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAcknowledgementChecked: false,
      isOkButtonDisabled: true,
    };
    this.onCheckboxClick = this.onCheckboxClick.bind(this);
    this.onSubmitButtonClick = this.onSubmitButtonClick.bind(this);
  }

  onCheckboxClick(checked) {
    this.setState({
      isAcknowledgementChecked: checked,
      isOkButtonDisabled: !checked,
    });
  }

  onSubmitButtonClick() {
    const {
      actions: { acknowledgeIRAContributionLimit },
      buttonActionPostHandler,
      closeModal,
    } = this.props;
    const { isAcknowledgementChecked } = this.state;

    if (buttonActionPostHandler) {
      buttonActionPostHandler();
    }
    acknowledgeIRAContributionLimit(isAcknowledgementChecked);
    closeModal(IRA_RECURRING_CONTRIBUTION_LIMIT_MODAL);
  }

  render() {
    const {
      customerWebViewEnabled,
      isSalesforceRep,
      executePurchase: {
        validation: { validationResults },
      },
      IRALimitData: {
        willExceedLimitAtEndOfYearWithNoChanges,
        currentYearLimitRange,
      },
      isValidated = false,
    } = this.props;

    const { willExceedCurrentYear, willExceedNextYear } =
      validationResults || {};
    const { isAcknowledgementChecked, isOkButtonDisabled } = this.state;
    const currentYear = moment().format('YYYY');
    const showWillExceedCurrentYearIRALimitMsg =
      isValidated &&
      (willExceedLimitAtEndOfYearWithNoChanges || willExceedCurrentYear);
    const showWillExceedNextYearIRALimitMsg =
      isValidated &&
      !showWillExceedCurrentYearIRALimitMsg &&
      willExceedNextYear;
    const showFallbackIRALimitMsg = !isValidated;
    return (
      <div className="ira-recurring-contribution-limit">
        <h3>IRA Contribution Limit</h3>
        <If test={showWillExceedCurrentYearIRALimitMsg}>
          <div>
            <span className="ira-recurring-contribution-limit-emphasize">
              {!customerWebViewEnabled && isSalesforceRep ? (
                <span>
                  This contribution amount and frequency will lead to an excess
                  contribution for this year and may also lead to excess
                  contributions in future years. It is your responsibility to
                  ensure that all contributions to your IRA are within the IRS
                  contribution limits.
                </span>
              ) : (
                <span>
                  This contribution amount and frequency will lead to an excess
                  contribution for this year and and may also lead to excess
                  contributions in future years.
                </span>
              )}
            </span>
          </div>
        </If>
        <If test={showWillExceedNextYearIRALimitMsg}>
          <div className="ira-recurring-contribution-limit-emphasize">
            {!customerWebViewEnabled && isSalesforceRep ? (
              <span>
                This amount and frequency will work for the remainder of this
                year but may lead to an excess contribution in future years. It
                is your responsibility to ensure that all contributions to your
                IRA are within the IRS contribution limits.
              </span>
            ) : (
              <span>
                This amount and frequency will work for the remainder of this
                year but may lead to an excess contribution in future years.
              </span>
            )}
          </div>
        </If>
        <If test={showFallbackIRALimitMsg}>
          <div className="ira-recurring-contribution-limit-emphasize">
            <span className="ira-recurring-contribution-limit-emphasize">
              <span>
                This recurring contribution amount will count toward your annual
                IRA contributions. It is your responsibility to ensure that all
                contributions to your IRA are within the IRS contribution
                limits.
              </span>
            </span>
          </div>
        </If>
        <p>
          For {currentYear}, your total contributions to all of your Traditional
          and Roth IRAs, with <TRP /> or other financial institutions, cannot be
          more than the lesser of:{' '}
          {normalizeCurrencyFormat(`$${currentYearLimitRange['minimum']}`)} (
          {normalizeCurrencyFormat(`$${currentYearLimitRange['maximum']}`)} if
          age 50 or older), or your taxable compensation for the year.
          Contribution amounts are subject to certain IRS imposed eligibility
          limits (such as income) depending on the type of IRA. For more
          information regarding IRA contributions, see IRS Publication 590-A or
          visit{' '}
          <a
            href="https://www.irs.gov"
            rel="noopener noreferrer"
            target="_blank"
          >
            IRS.gov
          </a>
          .
          <br />
        </p>
        <div className="ira-recurring-contribution-limit-label">
          <Checkbox
            ariaLabel="IRA Recurring Contribution Limit Acknowledgement"
            checked={isAcknowledgementChecked}
            id={`ira-recurring-contribution-checkbox`}
            inline
            onClick={(checked) => this.onCheckboxClick(checked)}
          />

          <label
            htmlFor={`ira-recurring-contribution-checkbox`}
            className={`ira-recurring-contribution-limit-sub-label`}
          >
            <span className="ira-recurring-contribution-limit-emphasize">
              {!customerWebViewEnabled && isSalesforceRep ? (
                <span>
                  I have read the above IRA contribution limit message to the
                  client.
                </span>
              ) : (
                <span>
                  I have read the IRA contribution limit message above and
                  understand I am responsible for making changes to the program,
                  as needed, to prevent excess contributions.
                </span>
              )}
            </span>
          </label>
        </div>
        <div className="ira-recurring-contribution-limit-button-container">
          <Button
            id={`ira-recurring-contribution-confirm`}
            buttonType="primary"
            disabled={isOkButtonDisabled}
            type="button"
            onClick={this.onSubmitButtonClick}
          >
            OK
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    isSalesforceRep: isSalesforceRep(state),
    executePurchase: getExecuteRecurringPurchase(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  IRARecurringContributionLimit
);
